module.exports = __webpack_public_path__ + "img/phox1.c5d062d3.png";